import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import '../styles/LoginPage.css';
import '../styles/Register.css';

export default function Register() {
    const [form, setForm] = useState({
        invitationCode: '',
        orgName: '',
        name: '',
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const set = key => e => setForm(prev => ({ ...prev, [key]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!form.invitationCode || !form.orgName || !form.name || !form.username || !form.email || !form.password) {
            setError('Bitte alle Felder ausfüllen (inkl. Einladungscode).');
            return;
        }
        if (form.password !== form.confirmPassword) {
            setError('Passwörter stimmen nicht überein.');
            return;
        }
        if (form.password.length < 8) {
            setError('Passwort muss mindestens 8 Zeichen lang sein.');
            return;
        }

        setLoading(true);
        try {
            await api.post('/auth/register', {
                org_name: form.orgName,
                name: form.name,
                username: form.username,
                email: form.email,
                password_clear: form.password,
                invitation_code: form.invitationCode.trim(),
            });
            setSuccess(true);
        } catch (err) {
            const detail = err.response?.data?.detail;
            if (detail === 'Username already taken') {
                setError('Dieser Benutzername ist bereits vergeben.');
            } else if (detail === 'Invitation code required') {
                setError('Bitte einen Einladungscode angeben.');
            } else if (detail === 'Invalid invitation code') {
                setError('Ungültiger Einladungscode.');
            } else if (detail === 'Invitation code already used') {
                setError('Dieser Einladungscode wurde bereits verwendet.');
            } else if (detail === 'Invitation code expired') {
                setError('Dieser Einladungscode ist abgelaufen.');
            } else {
                setError('Registrierung fehlgeschlagen. Bitte erneut versuchen.');
            }
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="reg-page">
                <div className="reg-card">
                    <Link to="/" className="reg-logo">
                        <span className="reg-logo-dot" />
                        Scalewisp
                    </Link>
                    <h2 className="reg-title">E-Mail bestätigen</h2>
                    <p className="reg-sub">
                        Wir haben eine Bestätigungs-E-Mail an <strong>{form.email}</strong> gesendet.
                        Bitte klicken Sie auf den Link in der E-Mail, um Ihr Konto zu aktivieren.
                    </p>
                    <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginTop: 8 }}>
                        Kein E-Mail erhalten? Prüfen Sie Ihren Spam-Ordner.
                    </p>
                    <p className="reg-footer-link" style={{ marginTop: 24 }}>
                        <Link to="/login">Zur Anmeldung</Link>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="reg-page">
            <div className="reg-card">
                <Link to="/" className="reg-logo">
                    <span className="reg-logo-dot" />
                    Scalewisp
                </Link>
                <h2 className="reg-title">Konto erstellen</h2>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="reg-field-group">
                        <label className="reg-label">Einladungscode</label>
                        <input
                            className="login-input"
                            type="text"
                            placeholder="XXXX-XXXX-XXXX"
                            value={form.invitationCode}
                            onChange={set('invitationCode')}
                            autoFocus
                        />
                    </div>

                    <div className="reg-field-group">
                        <label className="reg-label">Firmenname</label>
                        <input
                            className="login-input"
                            type="text"
                            placeholder="Muster GmbH"
                            value={form.orgName}
                            onChange={set('orgName')}
                        />
                    </div>

                    <div className="reg-field-row">
                        <div className="reg-field-group">
                            <label className="reg-label">Ihr Name</label>
                            <input
                                className="login-input"
                                type="text"
                                placeholder="Max Müller"
                                value={form.name}
                                onChange={set('name')}
                            />
                        </div>
                        <div className="reg-field-group">
                            <label className="reg-label">Benutzername</label>
                            <input
                                className="login-input"
                                type="text"
                                placeholder="max.mueller"
                                value={form.username}
                                onChange={set('username')}
                            />
                        </div>
                    </div>

                    <div className="reg-field-group">
                        <label className="reg-label">E-Mail-Adresse</label>
                        <input
                            className="login-input"
                            type="email"
                            placeholder="max@mustergmbh.de"
                            value={form.email}
                            onChange={set('email')}
                        />
                    </div>

                    <div className="reg-field-row">
                        <div className="reg-field-group">
                            <label className="reg-label">Passwort</label>
                            <input
                                className="login-input"
                                type="password"
                                placeholder="Min. 8 Zeichen"
                                value={form.password}
                                onChange={set('password')}
                            />
                        </div>
                        <div className="reg-field-group">
                            <label className="reg-label">Passwort wiederholen</label>
                            <input
                                className="login-input"
                                type="password"
                                placeholder="Passwort bestätigen"
                                value={form.confirmPassword}
                                onChange={set('confirmPassword')}
                            />
                        </div>
                    </div>

                    {error && <p className="login-error">{error}</p>}

                    <button className="button reg-submit" type="submit" disabled={loading}>
                        {loading ? 'Wird registriert…' : 'Konto erstellen'}
                    </button>
                </form>

                <p className="reg-footer-link">
                    Bereits registriert? <Link to="/login">Anmelden</Link>
                </p>
            </div>
        </div>
    );
}
